// imports
import Component from 'minsky-kit/js/components/Component';
import PageNav from './PageNav';
import SectionTracker from './SectionTracker';

// private statics
const VERSION = '1.0.0';

// class definition
export default class DayTab extends Component {
    // constructor
    constructor (args = {}, objectName = 'DayTab') {
        args.debug = args.debug || false;
        args.states = [
            {
                name:      'show',
                immediate: false,
                steps:     [
                    {
                        name:        'showing',
                        removeClass: ['tab--state-hidden', 'tab--state-hiding'],
                        addClass:    ['tab--state-showing'],
                        duration:    500,
                    },
                    {
                        name:        'shown',
                        removeClass: ['tab--state-showing'],
                        addClass:    ['shown'],
                        duration:    0,
                    },
                ],
            },
            {
                name:      'hide',
                immediate: false,
                steps:     [
                    {
                        name:        'hiding',
                        removeClass: ['tab--state-shown'],
                        addClass:    ['tab--state-hiding'],
                        duration:    0,
                    },
                    {
                        name:        'hidden',
                        removeClass: ['tab--state-hiding'],
                        addClass:    ['tab--state-hidden'],
                        duration:    500,
                    },
                ],
            },
        ];
        // super
        super(args, objectName);

        this.pageNav = null;
        this.sectionTracker = null;
    }

    // methods
    destroy () {
        // super destroy
        this.states.allClasses.forEach((c) => {
            this.el.classList.remove(c);
        });

        super.destroy();
    }

    show () {
        this.states.set('show');

        const $pageNav = this.el.querySelector('.page-nav');
        if ($pageNav) {
            // build pagenav
            const realSections = [];
            const $sections = this.el.querySelectorAll('.festival-artist');
            for (let i = 0; i < $sections.length; i++) {
                const $s = $sections[i];
                const $title = $s.querySelector('.festival-artist__title');
                if ($title) {
                    const $navEl = document.createElement('li');
                    $navEl.innerHTML = `<button data-section-id="${$s.dataset.sectionId}">${$title.innerHTML}</button>`;
                    $pageNav.querySelector('.page-nav__list').appendChild($navEl);
                    realSections.push($s);
                }
            }

            this.pageNav = new PageNav({
                el: $pageNav,
            });

            this.sectionTracker = new SectionTracker({
                sections: realSections,
            });

            if (this.sectionTracker.currentSection) {
                this.pageNav.activate(this.sectionTracker.currentSection.dataset.sectionId);
            }

            this.sectionTracker.on('change', this.blm.add('onSectionChange', onSectionChange));
            window.sectionTracker = this.sectionTracker;
            this.sectionTracker.refresh();
        }
    }

    hide () {
        this.states.set('hide');
        if (this.sectionTracker) this.sectionTracker.destroy();
        if (this.pageNav) this.pageNav.destroy();
        this.sectionTracker = null;
        this.pageNav = null;
        this.el.querySelector('.page-nav__list').innerHTML = '';
        window.sectionTracker = null;
    }

    // getters & setters
    static get version () { return VERSION; }
}

function onSectionChange (e) {
    // avoid nav stat changes while scroll is animating
    if (this.pageNav) {
        this.pageNav.activate(e.data.section.dataset.sectionId);
    }
}

// Utils

// Event handlers
